import { render, staticRenderFns } from "./CollectionsReport.vue?vue&type=template&id=a312204e"
import script from "./CollectionsReport.vue?vue&type=script&lang=ts"
export * from "./CollectionsReport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports